import "./index.scss";
import React, { useEffect } from "react";

interface MapProps {
  lat: number;
  lng: number;
}

export default function Map({ lat, lng }: MapProps) {
  function setupGoogleMaps() {
    const coordinates = { lat, lng };

    const mapEl = document.getElementById("Map");
    if (mapEl) {
      const map = new window.google.maps.Map(mapEl, {
        zoom: 16,
        center: coordinates,
        mapId: "STORE_MAP",
      });
      const marker = new google.maps.marker.AdvancedMarkerElement({
        position: coordinates,
        map,
      });
    }
  }
  useEffect(setupGoogleMaps, [lat, lng]);
  return <div id="Map" />;
}
